var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24613 8.7819L0.315783 7.06215C-0.127154 6.86849 -0.0971853 6.23024 0.362065 6.07915L15.3077 1.15218C15.6987 1.0234 16.0797 1.37246 15.9855 1.77346L12.9989 14.4719C12.9097 14.8513 12.4538 15.006 12.1523 14.7591L8.64297 11.8876L4.24613 8.7819Z",
    fill: "#57C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 3.89173L4.24561 8.77929L5.24201 13.4011C5.33139 13.8158 5.82014 13.9985 6.15964 13.7443L8.64248 11.885L6.59961 10.2132L12.6463 4.22276C12.8236 4.0471 12.603 3.76326 12.389 3.89173Z",
    fill: "#165274"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1211_5320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.389 3.89173L4.24561 8.77929L5.24201 13.4011C5.33139 13.8158 5.82014 13.9985 6.15964 13.7443L8.64248 11.885L6.59961 10.2132L12.6463 4.22276C12.8236 4.0471 12.603 3.76326 12.389 3.89173Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57153 13.8101C5.7546 13.8928 5.97894 13.882 6.1606 13.7459L8.64344 11.8867L7.622 11.0508L6.60056 10.2148L5.57153 13.8101Z",
    fill: "#2D89BC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1211_5320",
    x: 2.34561,
    y: 1.95938,
    width: 12.2655,
    height: 13.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1211_5320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1211_5320",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.9c5767f9260b6f8687671be88ebee9a2.svg";
export { ForwardRef as ReactComponent };